import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import './components/signup.css';
import whitesignup from './components/images/signup_whiite.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faHeart, 
  faComments,
  faCheckCircle, 
  faCalendarAlt, 
  faEye,
  faEyeSlash} from '@fortawesome/free-regular-svg-icons';
import {faChartPie, faSearch } from "@fortawesome/free-solid-svg-icons";

import { useLanguage } from "../../../i18n/LanguageContext";


function Signup() {

  const {register, formState:{errors}, handleSubmit, watch} = useForm();
  const { t } = useLanguage();
  const apiBaseUrl = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [signupError, setSignupError] = useState("");
  const onSubmit = async (data)=>{
    setSignupError("");
    setIsLoading(true);
      try {
    const response = await fetch("/api/signup", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });

    const result = await response.json();

    if (response.ok) {
      window.location.href = "/login";
    } else {
      setIsLoading(false);
      setSignupError(result.message || "Signup failed. Please try again.");
    }
  } catch (error) {
    setIsLoading(false);
    setSignupError("Unable to connect to server. Please try again.");
  }
  }
  const password = watch("password1");
  const role = watch("role");

  const startGoogleSignUp = () => {
    const roleParam = role === "owner" || role === "renter" ? `?role=${encodeURIComponent(role)}` : "";
    const targetUrl = apiBaseUrl ? `${apiBaseUrl}/api/auth/google${roleParam}` : `/api/auth/google${roleParam}`;
    window.location.href = targetUrl;
  };

  const [countryCode, setCountryCode] = useState([]);

  useEffect(()=>{
    const getCountryCode = async()=>{
      const reqData = await fetch("/api/countrycode");
      const resData = await reqData.json();

      const sorted = [...resData].sort((a,b)=>
        a.alpha_3.localeCompare(b.alpha_3)
      );
      setCountryCode(sorted);
    };
    getCountryCode();
  },[]);



  return (
    <div className="auth-page container">
      <div className="d-flex flex-column auth-info-panel">
        <div className="p-2 d-flex justify-content-center">
          <img src="/logo.png" alt="GharBhada logo" className="auth-brand-logo" />
        </div>
        <div className="d-flex justify-content-center">
            <h1>{t('signup.welcome')}</h1>
        </div>
        <div className="text-muted text-center">
              <p>{t('signup.subtitle')}</p>
        </div>
        <div className="d-flex mt-5 flex-column">
              <div className="d-flex flex-fill">
                <div className="p-2 features-svg">
                  <FontAwesomeIcon icon={faSearch} size="lg" className="text-primary" />
                </div>
                <div className="p-2 d-flex flex-column">
                  <p className="heading">{t('signup.feature1Title')}</p>
                  <p className="description text-muted">
                    {t('signup.feature1Desc')}
                  </p>
                </div>
              </div>
              <div className="d-flex flex-fill">
                <div className="p-2 features-svg">
                  <FontAwesomeIcon icon={faHeart} size="lg" className="text-primary" />
                </div>
                <div className="p-2 d-flex flex-column">
                  <p className="heading">{t('signup.feature2Title')}</p>
                  <p className="description text-muted">
                    {t('signup.feature2Desc')}
                  </p>
                </div>
              </div>
              <div className="d-flex flex-fill">
                <div className="p-2 features-svg">
                  <FontAwesomeIcon icon={faComments} size="lg" className="text-primary" />
                </div>
                <div className="p-2 d-flex flex-column">
                  <p className="heading">{t('signup.feature3Title')}</p>
                  <p className="description text-muted">
                    {t('signup.feature3Desc')}
                  </p>
                </div>
              </div>
              <div className="d-flex flex-fill">
                <div className="p-2 features-svg">
                  <FontAwesomeIcon icon={faCheckCircle} size="lg" className="text-primary" />
                </div>
                <div className="p-2 d-flex flex-column">
                  <p className="heading">{t('signup.feature4Title')}</p>
                  <p className="description text-muted">
                    {t('signup.feature4Desc')}
                  </p>
                </div>
              </div>
              <div className="d-flex flex-fill">
                <div className="p-2 features-svg">
                  <FontAwesomeIcon icon={faCalendarAlt} size="lg" className="text-primary" />
                </div>
                <div className="p-2 d-flex flex-column">
                  <p className="heading">{t('signup.feature5Title')}</p>
                  <p className="description text-muted">
                    {t('signup.feature5Desc')}
                  </p>
                </div>
              </div>
              <div className="d-flex flex-fill">
                <div className="p-2 features-svg">
                  <FontAwesomeIcon icon={faChartPie} size="lg" className="text-primary" />
                </div>
                <div className="p-2 d-flex flex-column">
                  <p className="heading">{t('signup.feature6Title')}</p>
                  <p className="description text-muted">
                    {t('signup.feature6Desc')}
                  </p>
                </div>
              </div>
        </div>
      </div>

      <div className="login d-flex flex-column auth-form-panel">
        <div className="d-flex justify-content-center">
          <img src="/icon.png" alt="GharBhada icon" width="70" height="70" className="d-inline-block align-top mx-2" />
        </div>
        <div className="d-flex justify-content-center">
          <h2>{t('signup.createAccount')}</h2>
        </div>
        <div className="d-flex justify-content-center ">
          <p className="form-description text-muted">
            {t('signup.subtitle')}
          </p>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group p-3">
            <label htmlFor="firstname">{t('signup.firstName')}<span className="text-danger">*</span></label>
            <input type="text" className="form-control" {...register("firstname", {required:true})} placeholder="Ex. John"/>
            <span className="text-danger">
              {errors.firstname?.type==="required" && t('signup.firstNameRequired')}
            </span>
          </div>
          <div className="form-group p-3">
            <label htmlFor="lastname">{t('signup.lastName')}<span className="text-danger">*</span></label>
            <input type="text" className="form-control" {...register("lastname", {required:true})} placeholder="Ex. Doe"/>
            <span className="text-danger">
              {errors.lastname?.type==="required" && t('signup.lastNameRequired')}
            </span>
          </div>
          <div className="form-group p-3">
            <label htmlFor="email">{t('signup.email')}<span className="text-danger">*</span></label>
            <input type="email" className="form-control" {...register("email", {required:true, pattern:/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$/i,})} placeholder="Ex. johndoe@xyz.com"/>
            <span className="text-danger">
              {errors.email?.type==="required" && t('signup.emailRequired')}
              {errors.email?.type==="pattern" && t('signup.emailInvalid')}
            </span>
          </div>
          <div className="form-group p-3">
            <label htmlFor="number">{t('signup.phone')}<span className="text-danger">*</span></label>
            <div className="phone-input-row">
              <div className="phone-code-select">
                <select className="form-select" {...register("countrycode", {required:true})}>
                  <option value="977">NPL +977</option>
                  {countryCode.map((countrycodeitem, index) => (
                    <option value={countrycodeitem.id} key={index}>
                      {countrycodeitem.alpha_3} +{countrycodeitem.phone}
                    </option>
                  ))}
                </select>
              </div>
              <div className="flex-fill">
                <input type="number" className="form-control" {...register("phnumber",{required:true, minLength:10, maxLength:12})} placeholder="Ex. 9841234567"/>
              </div>
            </div>
            <span className="text-danger">
              {errors.phnumber?.type==="required" && t('signup.phoneRequired')}
              {errors.phnumber?.type==="minLength" && t('signup.phoneInvalid')}
              {errors.phnumber?.type==="maxLength" && t('signup.phoneInvalid')}
              {errors.countrycode?.type==="required" && t('signup.selectRole')}
            </span>
          </div>
          <div className="form-group p-3">
            <label htmlFor="gender">{t('signup.gender')}<span className="text-danger">*</span></label>
            <select {...register("gender", {required:true})} className="form-select">
                <option value="">{t('signup.genderSelect')}</option>
                <option value="Male">{t('signup.genderMale')}</option>
                <option value="Female">{t('signup.genderFemale')}</option>
                <option value="Other">{t('signup.genderOther')}</option>
                <option value="None">{t('signup.genderNone')}</option>
              </select>
              <span className="text-danger">
                {errors.gender?.type==="required" && t('signup.genderRequired')}
              </span>
          </div>
          <div className="form-group p-3">
            <label htmlFor="role">{t('signup.role')}<span className="text-danger">*</span></label>
            <select {...register("role", {required:true})} className="form-select">
              <option value="">{t('signup.roleSelect')}</option>
              <option value="renter">{t('signup.roleRenter')}</option>
              <option value="owner">{t('signup.roleOwner')}</option>
            </select>
            <span className="text-danger">
              {errors.role?.type==="required" && t('signup.roleRequired')}
            </span>
          </div>
          <div className="form-group p-3">
            <label htmlFor="password1">{t('signup.createPassword')}<span className="text-danger">*</span></label>
            <div className="position-relative">
              <input 
                type={showPassword1 ? "text" : "password"} 
                className="form-control" 
                {...register("password1", {required:true, pattern:/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9])\S{8,}$/})} 
                placeholder="Please enter a password"
              />
              <button
                type="button"
                className="btn btn-link position-absolute end-0 top-50 translate-middle-y"
                onClick={() => setShowPassword1(!showPassword1)}
                style={{ textDecoration: 'none', zIndex: 10 }}
              >
                <FontAwesomeIcon icon={showPassword1 ? faEyeSlash : faEye} className="text-secondary" />
              </button>
            </div>
            <span className="text-danger">
              {errors.password1?.type==="required" && t('signup.passwordRequired')}
              {errors.password1?.type==="pattern" && t('signup.passwordInvalid')}
            </span>
          </div>
          <div className="form-group p-3">
            <label htmlFor="password2">{t('signup.confirmPassword')}<span className="text-danger">*</span></label>
            <div className="position-relative">
              <input 
                type={showPassword2 ? "text" : "password"} 
                className="form-control" 
                {...register("password2", {required:true, validate: value => value === password})} 
                placeholder="Please enter a password"
              />
              <button
                type="button"
                className="btn btn-link position-absolute end-0 top-50 translate-middle-y"
                onClick={() => setShowPassword2(!showPassword2)}
                style={{ textDecoration: 'none', zIndex: 10 }}
              >
                <FontAwesomeIcon icon={showPassword2 ? faEyeSlash : faEye} className="text-secondary" />
              </button>
            </div>
            <span className="text-danger">
              {errors.password2?.type==="required" && t('signup.passwordsMustMatch')}
              {errors.password2?.type==="validate" && t('signup.passwordsMustMatch')}
            </span>
          </div>
          <div className="form-group p-3 mt-2">
            <input type="checkbox" name="accept" {...register("accept", {required:true})} className="form-check-input" value="1"/>
            <label className="px-2">
              {t('signup.agreeTerms')}
              <span className="text-danger">*</span>
            </label>
            <span className="text-danger">
              {errors.accept?.type==="required" && t('signup.agreeRequired')}
            </span>
          </div>
          <div className="form-group p-3 my-2 d-flex flex-column">
            {signupError && (
              <div className="alert alert-danger py-2 px-3 w-100 mb-2 small">{signupError}</div>
            )}
            <button type="submit" className="btn btn-primary flex-fill" disabled={isLoading}>
              {isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  {t('signup.creating')}
                </>
              ) : (
                <>
                  <img src={whitesignup} width="30" height="30" className="d-inline-block align-top mx-2" alt="" />
                  {t('signup.createAccount')}
                </>
              )}
            </button>
            <div className="auth-divider mt-3"><span>or</span></div>
            <button type="button" className="google-auth-btn" onClick={startGoogleSignUp}>
              <span className="google-auth-btn__icon">
                <svg width="20" height="20" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.717v2.258h2.908C16.658 14.013 17.64 11.706 17.64 9.2z" fill="#4285F4"/>
                  <path d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z" fill="#34A853"/>
                  <path d="M3.964 10.707A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.707V4.961H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.039l3.007-2.332z" fill="#FBBC05"/>
                  <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.96L3.964 7.293C4.672 5.163 6.656 3.58 9 3.58z" fill="#EA4335"/>
                </svg>
              </span>
              <span className="google-auth-btn__text">Continue with Google</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Signup;
